/** Get a somewhat unique hash for the given Object by serializing it to JSON and hashing that string using Java's String.hash algorithm. */
export function hash(str) {
	let hash=0, i=0;
	for (; i<str.length; i++) {
		hash = ((hash<<5)-hash) + str.charCodeAt(i);
		hash &= hash;
	}
	return hash.toString(36).replace('-', '_');
}


/** Serialize an object into a querystring.
 *	Nested objects are serialized using PHP-style key notation (`foo[bar][baz]=1`).
 *	@param {Object} obj		Optionally-nested object to serialize.
 *	@returns {String} a=1&b=2&c[d]=3
 */
export function serializeQueryString(obj) {
	let parts = [];
	obj = flatten(obj);
	for (let i in obj) if (obj.hasOwnProperty(i)) {
		//eslint-disable-next-line eqeqeq
		parts.push( encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]!=null ? obj[i] : '') );
	}
	return parts.sort().join('&');
}


/** Parse a Stringified querystring into an Object.
 *	Note: does not support the key-nesting of its counterpart, serializeQueryString.
 *	@param {String} str		The string to parse as a querystring
 */
export function parseQueryString(str, separator='&', assignment='=') {
	let values = str.split(separator),
		obj = {};
	for (let i=0; i<values.length; i++) {
		let parts = values[i].split(assignment);
		obj[trim(decodeURIComponent(parts[0]))] = trim(decodeURIComponent(parts.slice(1).join('=')));
	}
	return obj;
}


/** Trim leading/trailing whitespace from a string (ponyfill for String.prototype.trim)*/
const trim = str => str.replace(/(^\s+|\s+$)/g, '');


/** Flatten an object, converting nested keys using PHP querystring style notation.
 *	@param {Object} obj		The nested object to flatten
 */
function flatten(obj, out, prefix) {
	let count = 0;
	out = out || {};

	for (let i in obj) if (obj.hasOwnProperty(i)) {
		let key = prefix ? `${prefix}[${i}]` : i,
			value = obj[i];

		count++;

		if (value && typeof value==='object') {
			flatten(value, out, key);
		}
		else {
			out[key] = value;
		}
	}

	if (!count && prefix) {
		out[prefix] = '';
	}

	return out;
}



// WEBPACK FOOTER //
// ../node_modules/@cube/framework-service/src/util.js